import { useQuery } from "react-query";
import axios from "axios";

export default function useUserEmails({ userId }) {
  let pathAndHost = window.location.protocol + window.location.host;
  return useQuery(
    ["users", userId, "emails"],
    async () => {
      let url = new URL(`/api/v2/users/${userId}/emails`, pathAndHost);

      let result;

      try {
        result = await axios.get(url.toString());
      } catch (err) {
        throw err;
      }
      
      return result.data;
    },
    { refetchOnWindowFocus: false }
  );
}
